export enum FeatureCode {
    CUSTOM_TIME_BUCKETS = "CUSTOM_TIME_BUCKETS",
    MULTI_STRIKE_OI_CHARTS_MULTISTRIKE = "MULTI_STRIKE_OI_CHARTS_MULTISTRIKE",
    CHART_ALERTS="CHART_ALERTS",
    SECURITY_EXPRESSIONS="SECURITY_EXPRESSIONS",
    DATA_EXPORT="DATA_EXPORT",
    PAYOFF_CHART_INTERACTIONS="PAYOFF_CHART_INTERACTIONS",
    SCREENER_SUBSCRIPTION="SCREENER_SUBSCRIPTION",
    SCREENER_DATA_EXPORT="SCREENER_DATA_EXPORT",
    STRATEGY_CHART_ACCESS="STRATEGY_CHART_ACCESS",
    COMMUNITY_WATCHLIST_ACCESS="COMMUNITY_WATCHLIST_ACCESS",
    SIMULATOR_FULL_ACCESS="SIMULATOR_FULL_ACCESS",
    MULTI_STRIKE_FULL_ACCESS='MULTI_STRIKE_FULL_ACCESS',
    SCALPER_FULL_ACCESS="SCALPER_FULL_ACCESS",
    PAST_EXPIRY="PAST_EXPIRY"
}

export const FEATURE_LABEL: Record<FeatureCode, string> = {
    [FeatureCode.CUSTOM_TIME_BUCKETS]: "Custom Timebuckets",
    [FeatureCode.CHART_ALERTS]:"Alerts",
    [FeatureCode.MULTI_STRIKE_OI_CHARTS_MULTISTRIKE]:"OI Charts",
    [FeatureCode.SECURITY_EXPRESSIONS]:"Security expressions",
    [FeatureCode.DATA_EXPORT]:"Chart data export",
    [FeatureCode.PAYOFF_CHART_INTERACTIONS]:"Payoff chart interactions",
    [FeatureCode.SCREENER_SUBSCRIPTION]:"Screener subscriptions",
    [FeatureCode.SCREENER_DATA_EXPORT]:"Screener data export",
    [FeatureCode.STRATEGY_CHART_ACCESS]:"Strategy chart",
    [FeatureCode.COMMUNITY_WATCHLIST_ACCESS]:"Community watchlists",
    [FeatureCode.SIMULATOR_FULL_ACCESS]:"Simulator",
    [FeatureCode.MULTI_STRIKE_FULL_ACCESS]:"Multi Strike Chart",
    [FeatureCode.SCALPER_FULL_ACCESS]:"Scalper",
    [FeatureCode.PAST_EXPIRY]:"Past expiries"
};